// extracted by mini-css-extract-plugin
export default {"page__title":"HomePage_page__title__k7Scb","form":"HomePage_form__kRuF2","form__fields":"HomePage_form__fields__zZg8I","form__button":"HomePage_form__button__TApP8"};